<div class="mat-table-wrapper">
  <form>
    <mat-table class="lmat-elevation-z8" [dataSource]="dataSource" matSort #sort1="matSort">
      <ng-container matColumnDef="application_name">
        <mat-header-cell *matHeaderCellDef class="mat-column-application_name" mat-sort-header>
          Application
        </mat-header-cell>
        <mat-cell *matCellDef="let device" class="mat-column-application_name">
          {{ device.application_name }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="ipAddress">
        <mat-header-cell *matHeaderCellDef class="mat-column-ipAddress" mat-sort-header>
          IP Address
        </mat-header-cell>
        <mat-cell *matCellDef="let device" class="mat-column-ipAddress">
          <span>{{ device.ipAddress }}</span>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="created">
        <mat-header-cell *matHeaderCellDef class="mat-column-created" mat-sort-header>
          Login Time
        </mat-header-cell>
        <mat-cell *matCellDef="let device" class="mat-column-created">
          {{ device.created | date : 'MM-dd-yy h:mm a' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef class="mat-column-status" mat-sort-header>
          Login Status
        </mat-header-cell>
        <mat-cell *matCellDef="let device" class="mat-column-status">
          <div class="col">
            <div>{{ device.status }}</div>
            <div>{{ device.failureReason }}</div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="terminationTime">
        <mat-header-cell *matHeaderCellDef class="mat-column-terminationTime" mat-sort-header>
          Termination Time
        </mat-header-cell>
        <mat-cell *matCellDef="let device" class="mat-column-terminationTime">
          {{ device.terminationTime | date : 'MM-dd-yy h:mm a' }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="terminationReason">
        <mat-header-cell *matHeaderCellDef class="mat-column-terminationReason" mat-sort-header>
          Terminarion Reason
        </mat-header-cell>
        <mat-cell *matCellDef="let device" class="mat-column-terminationReason">
          {{ device.terminationReason }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </form>
  <div class="mat-table-bottom">
    <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
    <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
    <!-- MATERIAL PAGINATOR | Binded to dasources -->
    <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
    <mat-paginator
      [pageSize]="10"
      [pageSizeOptions]="[10, 25, 50, 200]"
      [length]="dataSource.paginatorTotal$ | async"
      [showFirstLastButtons]="true"
    ></mat-paginator>
  </div>
</div>
